import { isValidIban } from "./payoutExport";

export const TERMS_VERSION = "2026-08-11";
export const PRIVACY_VERSION = "2025-07-21";

export const SUPPORTED_ONBOARDING_COUNTRIES = [
    {code: "AT", name: "Austria"},
    {code: "BE", name: "Belgium"},
    {code: "BG", name: "Bulgaria"},
    {code: "HR", name: "Croatia"},
    {code: "CY", name: "Cyprus"},
    {code: "EE", name: "Estonia"},
    {code: "FI", name: "Finland"},
    {code: "FR", name: "France"},
    {code: "DE", name: "Germany"},
    {code: "GR", name: "Greece"},
    {code: "IE", name: "Ireland"},
    {code: "IT", name: "Italy"},
    {code: "LV", name: "Latvia"},
    {code: "LT", name: "Lithuania"},
    {code: "LU", name: "Luxembourg"},
    {code: "MT", name: "Malta"},
    {code: "NL", name: "Netherlands"},
    {code: "PT", name: "Portugal"},
    {code: "SK", name: "Slovakia"},
    {code: "SI", name: "Slovenia"},
    {code: "ES", name: "Spain"},
];

export const normalizeBusinessID = (value) => String(value || "")
    .normalize("NFKD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/&/g, "-and-")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .replace(/-{2,}/g, "-")
    .slice(0, 48);

export const isSelfServiceSignupEnabled = () => {
    const configured = process.env.REACT_APP_SELF_SERVICE_SIGNUP_ENABLED;
    if (typeof configured === "string") return configured.toLowerCase() === "true";
    return process.env.NODE_ENV !== "production"
        || process.env.REACT_APP_FIREBASE_PROJECT_ID === "tiply-app-test";
};

export const isBusinessActive = (business) => {
    if (!business) return false;
    if (business.onboardingStatus) return business.onboardingStatus === "ACTIVE";
    return business.verified !== false;
};

export const getEmployeeReadinessIssue = (employee, business) => {
    if (!String(employee?.displayName || employee?.name || "").trim()) return "Add a display name";
    if (!String(employee?.firstName || "").trim()) return "Add their legal first name";
    if (!String(employee?.lastName || "").trim()) return "Add their legal last name";
    if (!isValidIban(employee?.iban)) return "Add a valid IBAN";
    const roles = new Set(
        (business?.config?.roles || [])
            .map((entry) => String(entry?.role || "").trim().toLowerCase())
            .filter(Boolean),
    );
    const role = String(employee?.role || "").trim().toLowerCase();
    if (!role || !roles.has(role)) return "Choose a payout role";
    return "";
};

export const onboardingStatusLabel = (status) => ({
    SETUP: "Setup in progress",
    PENDING_REVIEW: "Pending Tiply review",
    CHANGES_REQUESTED: "Changes requested",
    ACTIVE: "Active",
    REJECTED: "Application closed",
}[status] || "Legacy business");
